<template>
  <v-container>
    <v-flex xs12 sm12>
      <v-card>
        <v-card-text class="small-font">
            <div><b>{{ disclaimer_bold }}</b> {{disclaimer_regular}}</div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      disclaimer_bold: "No Medical Advice Given. ",
      disclaimer_regular: "The information on this Site is for informational purposes only and is not intended as a substitute for medical professional help, advice, diagnosis or treatment. Always seek the advice of your physician or other qualified health care provider with any questions that you have regarding your medical care. Nothing in this Site is intended as a recommendation or endorsement of any specific tests, products, procedures, companies, opinions, or other information that may be mentioned in this Site. Any reliance on any information provided by the Site personnel, others appearing on the Site at the invitation of the website and/or other visitors to the Site is solely at the user's risk. Information on this Site is not intended to create any provider-patient relationship."
    }
  }
}
</script>

<style lang="stylus" scoped>
    .small-font {
        font-size: 0.8em;
    }
</style>